import React, { useEffect, useRef, useState } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import ApiCaller from "../../api/ApiCaller";
import { GET_DASHBOARD_FOR_USER } from "../../api/ApiConst";
import "../../css/DashboardView.css";
import ChartCard from "./dashboardviews/ChartCard";
import StatCard from "./dashboardviews/StatCard";
import TableCard from "./dashboardviews/TableCard";

const ResponsiveGridLayout = WidthProvider(Responsive);

const DashboardView = () => {
    const [dashboardItems, setDashboardItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const hasFetchedData = useRef(false);

    const fetchDashboardItems = () => {
        ApiCaller.callGetApi(
            GET_DASHBOARD_FOR_USER,
            {},
            (response) => {
                setDashboardItems(response.items || []);
                setIsLoading(false);
            },
            (error) => {
                setError("Failed to load dashboard data.");
                setIsLoading(false);
            }
        );
    };

    useEffect(() => {
        if (!hasFetchedData.current) {
            hasFetchedData.current = true;
            fetchDashboardItems();
        }
    }, []);

    // Layout mapping logic
    const layout = dashboardItems.map((item) => ({
        i: item.id?.toString(),
        x: item.column - 1, // Zero-based column index
        y: item.row - 1, // Zero-based row index
        w: item.expandH || 1, // Horizontal expand (number of columns to span)
        h: item.expandV || 1, // Vertical expand (number of rows to span)
        static: false, // Allow drag and resize
    }));

    const breakpoints = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 };
    const cols = { lg: 12, md: 10, sm: 8, xs: 6, xxs: 4 };

    if (isLoading) {
        return <p>Loading dashboard...</p>;
    }

    if (error) {
        return <p className="error">{error}</p>;
    }

    // Helper function to render items based on viewType
    const renderDashboardItem = (item) => {
        switch (item.viewType) {
            case "TABLE_VIEW":
                return <TableCard item={item} />;
            case "SINGLE_DATA_VIEW":
                return <StatCard item={item} />;
            case "CHART_VIEW":
                return <ChartCard item={item} />;
            default:
                return <div>Unsupported view type: {item.viewType}</div>;
        }
    };

    return (
        <div className="dashboard-view">
            <h3>Dashboard</h3>
            <ResponsiveGridLayout
                className="layout"
                layouts={{ lg: layout }}
                breakpoints={breakpoints}
                cols={cols}
                rowHeight={30} // Height of a single row in pixels
                margin={[10, 10]} // Margin between items [horizontal, vertical]
                containerPadding={[20, 20]} // Padding inside the grid container [horizontal, vertical]
                isResizable={true}
                isDraggable={true}
            >
                {dashboardItems.map((item) => (
                    <div key={item.id?.toString()} className="dashboard-item">
                        {renderDashboardItem(item)}
                    </div>
                ))}
            </ResponsiveGridLayout>
        </div>
    );
};

export default DashboardView;
